module.exports = __webpack_public_path__ + "static/media/PGL02@s.a8ab9ae4.jpg";